import React from "react";

export default function RefundPolicyPage() {
    return (
        <div style={styles.wrap}>
            <div style={styles.inner}>

                <h2 style={styles.title}>
                    환불 · 교환 · 반품 안내
                </h2>

                <p style={styles.description}>
                    네리네쇼핑몰은 떡케이크 및 음료 특성상
                    식품위생과 신선도 유지를 위해 아래 기준에 따라
                    교환 및 환불을 운영하고 있습니다.
                </p>

                <section style={styles.section}>
                    <h3 style={styles.sectionTitle}>
                        1. 주문 취소 안내
                    </h3>

                    <ul style={styles.list}>
                        <li>주문 취소는 제작 시작 전까지만 가능합니다.</li>
                        <li>주문 제작 이후에는 취소가 제한될 수 있습니다.</li>
                        <li>픽업/배송 당일 취소는 환불이 어려울 수 있습니다.</li>
                    </ul>
                </section>

                <section style={styles.section}>
                    <h3 style={styles.sectionTitle}>
                        2. 교환 및 환불 가능 사항
                    </h3>

                    <ul style={styles.list}>
                        <li>상품 파손 또는 심한 훼손</li>
                        <li>주문 상품과 다른 상품 배송</li>
                        <li>상품 변질 및 이상 발생</li>
                    </ul>

                    <div style={styles.customerBox}>
                        <p style={styles.customerText}>
                        수령 직후 사진 촬영 후 고객센터로 접수 부탁드립니다.
                        </p>
                    </div>
                </section>

                <section style={styles.section}>
                    <h3 style={styles.sectionTitle}>
                        3. 교환 및 환불 불가 사항
                    </h3>

                    <ul style={styles.list}>
                        <li>단순 변심</li>
                        <li>고객 부주의로 인한 훼손</li>
                        <li>섭취 또는 사용 완료 상품</li>
                        <li>장시간 보관으로 품질이 변한 상품</li>
                        <li>문구/디자인이 포함된 주문 제작 떡케이크</li>
                    </ul>
                </section>

                <section style={styles.section}>
                    <h3 style={styles.sectionTitle}>
                        4. 환불 처리 안내
                    </h3>

                    <ul style={styles.list}>
                        <li>환불 승인 후 영업일 기준 3~7일 이내 처리됩니다.</li>
                        <li>카드 환불은 카드사 일정에 따라 달라질 수 있습니다.</li>
                        <li>계좌 환불은 계좌 확인 후 진행됩니다.</li>
                    </ul>
                </section>

                <section>
                    <h3 style={styles.sectionTitle}>
                        5. 고객센터 안내
                    </h3>

                    <div style={styles.customerBox}>
                        <p style={styles.customerText}>
                            운영시간 : 평일 오전 10시 ~ 오후 6시
                        </p>

                        <p style={styles.customerText}>
                            주말 및 공휴일 휴무
                        </p>
                    </div>
                </section>

            </div>
        </div>
    );
}

const styles = {
    wrap: {
        width: '100%',
        background: '#fff',
        marginTop: '40px',
        padding: '0px 0'
    },

    inner: {
        width: '100%',
        padding: '0 0px',
        maxWidth: '1110px',
        margin: '0 auto'
    },

    title: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#222',
        marginBottom: '18px'
    },

    description: {
        fontSize: '16px',
        color: '#666',
        lineHeight: '1.8',
        marginBottom: '35px'
    },

    section: {
        marginBottom: '35px'
    },

    sectionTitle: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#222',
        marginBottom: '14px'
    },

    list: {
        color: '#666',
        fontSize: '14px',
        paddingLeft: '18px',
        lineHeight: '2'
    },

    noticeBox: {
        marginTop: '15px',
        padding: '14px',
        background: '#fff8e8',
        borderRadius: '6px',
        color: '#9a6700',
        fontSize: '13px',
        lineHeight: '1.7'
    },

    customerBox: {
        background: '#f8f8f8',
        padding: '18px',
        borderRadius: '8px'
    },

    customerText: {
        margin: '0 0 6px 0',
        fontSize: '14px',
        color: '#555',
        lineHeight: '1.8'
    }
};